import React from 'react';

import { styles } from './generalStyles';
import WalletLink from 'walletlink'
import Web3Modal from "web3modal";
import Web3 from "web3";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Torus from "@toruslabs/torus-embed";
import { CHAIN_EXPLORER, CHAIN_HEX, CHAIN_ID, CHAIN_NAME, CONTRACT_ADDRESS, INFURA_ID, INFURA_URL, PRIMARY_BUTTON_BACKGROUND_COLOR } from './constants';
import { BigNumber } from 'ethers';

import coin from './assets/boule.png';
import { isMobile } from 'react-device-detect';
import ModalComponent from './ModalComponent';
import NumericInput from 'react-numeric-input';

const contract = require("./BillionDollarMint.json");
const contractAddress = CONTRACT_ADDRESS;

const ethers = require('ethers');

const dic_net = {
    name: 'polygon',
    chainId: CHAIN_ID,
    _defaultProvider: (providers: any) => new providers.JsonRpcProvider(INFURA_URL)
};

const provider = ethers.getDefaultProvider(dic_net);

const defaultNftContract = new ethers.Contract(contractAddress, contract.abi, provider);

const web3Modal = new Web3Modal({
    network: "polygon", // optional
    cacheProvider: true, // optional
    providerOptions: {
        walletlink: {
            package: WalletLink, // Required
            options: {
                appName: "Boulé",
                infuraId: INFURA_ID,
                chainId: CHAIN_ID, // Optional. It defaults to 1 if not provided
            }
        },
        walletconnect: {
            package: WalletConnectProvider, // required
            options: {
                infuraId: INFURA_ID
            }
        },
        torus: {
            package: Torus, // required
            options: {
                networkParams: {
                    chainId: CHAIN_ID, // optional
                    networkId: CHAIN_ID // optional
                },
            }
        }
    }
});

type Props = {
    setConnected: (connected: boolean) => void,
};

type State = {
    ticketCount: number,
    ticketIds: string[],
    poolSize: number,
    localAccount: string,
    localTransactionState: string,
    web3?: Web3,
    componentIsReady: boolean,
    winningTicketId: number,
    nftContract?: any,
    showModal: boolean,
    showMintModal: boolean,
    quantity: number,
    onCorrectNetwork: boolean,
};

const lightBorder = () => <div style={{ width: '100%', height: .5, backgroundColor: '#aaaaaa', marginBottom: 50 }} />;

export default class ConnectWallet extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            ticketCount: 0,
            ticketIds: [],
            poolSize: 0,
            localAccount: '',
            localTransactionState: 'Success',
            componentIsReady: false,
            winningTicketId: 0,
            showModal: false,
            showMintModal: false,
            quantity: 1,
            onCorrectNetwork: false,
        }
    }

    componentDidMount() {
        this.refreshInfo();

        if (window.localStorage.getItem('hasBeenOnWebsite')) {
            this.handleConnectWallet();
        }
        window.localStorage.setItem('hasBeenOnWebsite', 'true');

        setTimeout(() => {
            this.setState({ componentIsReady: true });
        }, 100);
    }

    refreshInfo = async () => {
        const { localAccount, nftContract, onCorrectNetwork } = this.state;

        if (!nftContract || !onCorrectNetwork) {
            // using the public provider, not connected
            defaultNftContract.getPoolSize().then((res: BigNumber, err: any,) => {
                this.setState({ poolSize: parseInt(res.toString()) / 1000000000000000000 });
            });

            return;
        }

        nftContract.methods.getTokensForAddress(localAccount).call((err: any, res: any) => {
            if (!res || err) return;
            this.setState({ ticketCount: res?.length || 0, ticketIds: res?.map((id: number) => `#${id}`) || [] });
        });

        nftContract.methods.getPoolSize().call((err: any, res: any) => {
            if (err) return;
            this.setState({ poolSize: isNaN(res) ? 0 : res / 1000000000000000000 });
        });

        nftContract.methods.getWinningTokenId().call((err: any, res: any) => {
            if (err) return;
            this.setState({ winningTicketId: isNaN(res) ? 0 : parseInt(res) });
        });
    }

    mintTicket = async () => {
        const { localAccount, web3, nftContract, quantity } = this.state;
        const nonce = await web3?.eth.getTransactionCount(localAccount, 'latest'); //get latest nonce
        const gasPrice = await web3?.eth.getGasPrice();
        const value = web3?.utils.toBN('1000000000000000000').muln(quantity);

        this.setState({ localTransactionState: 'Minting' });
        web3?.eth.sendTransaction({
            from: localAccount,
            to: contractAddress,
            nonce,
            gas: 500000 * quantity,
            gasPrice,
            value,
            data: nftContract.methods.mintToken(quantity).encodeABI(),
        }).on('sending', () => {
            this.updateTxState('Sending');
        }).on('error', () => {
            this.updateTxState('Exception');
        }).on('transactionHash', (r) => {
            console.log('transactionHash')
            console.log(r)
        }).on('receipt', (r) => {
            console.log('receipt')
            console.log(r)
        }).on('confirmation', (c, r) => {
            console.log('confirmation')
            console.log(c, r);
            if (c === 24) {
                this.updateTxState('Success');
            }
        });
    };

    updateTxState = (localTransactionState: string) => {
        this.setState({ localTransactionState });
        this.refreshInfo();
    }

    handleConnectWallet = async () => {
        const provider = await web3Modal.connect();
        const web3 = new Web3(provider);
        const nftContract = new web3.eth.Contract(contract.abi, contractAddress);

        const accounts = await web3.eth.getAccounts();
        if (!accounts.length) {
            this.props.setConnected(false);
            return;
        }

        this.props.setConnected(true);
        this.setState({ web3, localAccount: provider.selectedAddress, nftContract });

        const chainId = await web3.eth.getChainId();
        this.setState({ onCorrectNetwork: chainId === CHAIN_ID });

        this.refreshInfo();

        setInterval(async () => {
            const { onCorrectNetwork } = this.state;
            const networkId = await web3?.eth.getChainId();

            const newOnCorrectNetwork = networkId === CHAIN_ID;
            this.setState({ onCorrectNetwork: newOnCorrectNetwork });

            if (newOnCorrectNetwork && !onCorrectNetwork) {
                this.refreshInfo();
            }
        }, 500);

        setInterval(async () => {
            const { localAccount } = this.state;

            const accounts = await web3.eth.getAccounts();
            if (localAccount === accounts[0] || (!localAccount && !accounts.length)) {
                return;
            }

            if (!accounts.length) {
                this.props.setConnected(false);
                this.setState({ localAccount: '', ticketCount: 0, ticketIds: [] });
                this.refreshInfo();
                return;
            }

            this.setState({ localAccount: accounts[0] });
            this.refreshInfo();
        }, 500);
    }

    switchChain = async () => {
        const { web3 } = this.state;
        try {
            // @ts-ignore
            await web3.eth.currentProvider.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: CHAIN_HEX }], // chainId must be in hexadecimal numbers
            });
        } catch (e: any) {
            // @ts-ignore
            await web3.eth.currentProvider.request({
                method: "wallet_addEthereumChain",
                params: [
                    {
                        chainId: CHAIN_HEX,
                        chainName: CHAIN_NAME,
                        rpcUrls: ['https://polygon-rpc.com'],
                        nativeCurrency: {
                            name: "Matic",
                            symbol: "MATIC",
                            decimals: 18,
                        },
                        blockExplorerUrls: [CHAIN_EXPLORER],
                    },
                ]
            });
        }
    }

    getConnectComponent = () => {
        const { localAccount, onCorrectNetwork } = this.state;
        return <>
            <div
                className='clickable'
                onClick={!localAccount ? this.handleConnectWallet : () => { }}
                style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...(!localAccount ? styles.enabledButton : styles.disabledButton), ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
            >
                <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{localAccount ? 'Wallet Connected ✅' : 'Connect Wallet'}</p>
            </div>
            <div
                className='clickable'
                onClick={localAccount ? this.switchChain : () => { }}
                style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...((onCorrectNetwork || !localAccount) ? styles.disabledButton : styles.enabledButton), ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
            >
                <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{onCorrectNetwork ? 'On Polygon ✅' : 'Connect to Polygon'}</p>
            </div>
        </>
    }

    render() {
        const {
            localAccount,
            poolSize,
            ticketCount,
            ticketIds,
            localTransactionState,
            componentIsReady,
            winningTicketId,
            showModal,
            showMintModal,
            quantity,
            onCorrectNetwork
        } = this.state;

        const isMinting = !(localTransactionState === 'Exception' || localTransactionState === 'Success');

        return (
            <>
                {winningTicketId ? <>
                    <p style={{ marginBottom: 0, textAlign: 'center' }}>{'WINNING TICKET'}</p>
                    <div style={{ marginTop: 5, ...styles.bold, ...styles.header2, display: 'flex', justifyContent: 'center', color: PRIMARY_BUTTON_BACKGROUND_COLOR }}>{`#${winningTicketId}`}</div>
                    <div style={{ marginTop: 5, ...styles.bold, ...styles.header4, display: 'flex', justifyContent: 'center', color: PRIMARY_BUTTON_BACKGROUND_COLOR }}>FOR {poolSize} MATIC</div>
                </> :
                    <>
                        <p style={{ marginBottom: 0, textAlign: 'center' }}>{'CURRENT POT'}</p>
                        <div style={{ marginTop: 5, ...styles.bold, ...styles.header1, display: 'flex', justifyContent: 'center', color: PRIMARY_BUTTON_BACKGROUND_COLOR }}>{poolSize} MATIC</div>

                        {/* <div style={{ marginTop: 5, ...styles.bold, ...styles.header3, display: 'flex', justifyContent: 'center', color: PRIMARY_BUTTON_BACKGROUND_COLOR }}><Countdown date={new Date('05/04/2022')} daysInHours={false} /></div> */}
                    </>
                }
                <div style={{ flexGrow: 1, display: 'flex', width: '100%' }}>
                    {componentIsReady && <div style={{ ...styles.defaultBackgroundColor, ...styles.centerJustified, height: '100%', width: '100%', ...styles.paddingExtra }}>
                        {(!Boolean(localAccount) || !onCorrectNetwork) ? this.getConnectComponent() : <>
                            {!isMinting ? <>
                                {Boolean(localAccount) && <p style={{ ...styles.text, ...{ textAlign: 'center' }, ...styles.marginBottomExtra, ...styles.flexRowSpaceBetween, display: 'flex', flexDirection: 'row', }}><span>You own: </span><span style={styles.bold}>{`${ticketCount} ticket${ticketCount === 1 ? '' : 's'}`}</span></p>}
                                {(!Boolean(winningTicketId) || !localAccount) && <div
                                    className='clickable'
                                    onClick={() => this.setState({ showMintModal: true })}
                                    style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
                                >
                                    <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'Mint a Ticket'}</p>
                                </div>}
                                {Boolean(ticketIds.length) && <div
                                    className='clickable'
                                    onClick={() => this.setState({ showModal: true })}
                                    style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
                                >
                                    <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'See My Tickets'}</p>
                                </div>}
                            </> : <p style={{ ...styles.text, ...{ textAlign: 'center' }, ...styles.bold }}>Creating Your Ticket...</p>}
                        </>}
                    </div>}
                </div >
                <ModalComponent
                    showModal={showModal}
                    onRequestClose={() => this.setState({ showModal: false })}
                >
                    <div style={{ ...styles.marginBottomExtra, ...styles.header3, ...styles.marginBottom }}><b>{'YOUR TICKETS'}</b></div>
                    {lightBorder()}
                    <div style={{ display: 'flex', flexDirection: 'row', overflow: 'scroll', }}>
                        {ticketIds.map((id, index) => {
                            return (
                                <div key={`${id}`} style={{ ...(index < ticketIds.length - 1 ? styles.marginRight : {}) }}>
                                    <img alt={`boule-${id}`} style={{ height: 100, borderRadius: 10 }} src={coin} />
                                    <p style={{ ...styles.centerText, marginTop: 0 }}>{id}</p>
                                </div>
                            );
                        })}
                    </div>
                    <p style={{ ...(isMobile ? { fontSize: 11 } : {}) }}>Contract address: <b>{contractAddress}</b></p>
                    <div
                        className='clickable'
                        onClick={() => this.setState({ showModal: false })}
                        style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
                    >
                        <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'Done'}</p>
                    </div>
                </ModalComponent>
                <ModalComponent
                    showModal={showMintModal}
                    onRequestClose={() => this.setState({ showMintModal: false })}
                >
                    <div style={{ ...styles.marginBottomExtra, ...styles.header3, ...styles.marginBottom }}><b>{'MINT TICKET'}</b></div>
                    {lightBorder()}
                    <div style={{ ...styles.flexRowSpaceBetween, display: 'flex', ...styles.text, ...styles.marginBottomExtra, ...styles.centerAligned }}>
                        <span>Quantity:</span>
                        <NumericInput
                            defaultValue={quantity}
                            min={1}
                            mobile={true}
                            width={50}
                            style={{
                                wrap: {
                                    display: 'flex',
                                    marginLeft: 20,
                                },
                                input: {
                                    maxWidth: 200
                                }
                            }}
                            onChange={(quantity) => {
                                this.setState({ quantity: quantity || 1 });
                            }}
                        />
                    </div>
                    <div
                        className='clickable'
                        onClick={() => {
                            this.mintTicket();
                            this.setState({ showMintModal: false });
                        }}
                        style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
                    >
                        <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'Mint'}</p>
                    </div>
                </ModalComponent>
            </>
        );
    }
}
